let pageConfig = {};

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "家充无忧套餐包",
  },
  {
    type: "title",
    name: "家充无忧套餐包列表",
  },
];
// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "家充无忧套餐包",
  },
  {
    type: "router",
    name: "家充无忧套餐包列表",
    router: "packageList",
  },
  {
    type: "title",
    name: "家充无忧套餐包编辑",
  },
];

// 列表-分页参数
pageConfig.pagination = {
  current: 0,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

export default pageConfig;
